import React, { useCallback, useMemo } from 'react';
import { StringMap, TOptionsBase } from 'i18next';
import { useTranslation as useI18NextTranslation } from 'react-i18next';

import { Props, TranslateProviderContextType } from './TranslationProvider.types';

export const TranslateProviderContext = React.createContext<TranslateProviderContextType>({
  t: () => '',
});

export const namespaces: string[] = [
  'common',
  'pages/candidates',
  'pages/clients',
  'pages/projects',
  'pages/recruitments',
  'pages/emails',
];

const TranslateProvider: React.FC<Props> = ({ i18n, children, waitForTranslations }) => {
  const { t: translate, ready } = useI18NextTranslation(namespaces, {
    useSuspense: false,
    i18n,
  });
  const t = useCallback(
    (key: string, options?: TOptionsBase | StringMap) => translate(key, options ?? {}),
    [translate]
  );
  const context = useMemo(() => ({ t }), [t]);

  if (!ready && waitForTranslations) {
    return <></>;
  }

  return <TranslateProviderContext.Provider value={context}>{children}</TranslateProviderContext.Provider>;
};

export default TranslateProvider;
